import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { fetchContentCollection } from "../../behavior/api/content";
import { ArticleCardList } from "../common";
import { Heading, HorizontalLine } from "../elements";

const InterviewGuides = () => {
    const { t } = useTranslation();
    const { data: contentCollection, isLoading: loading } = useQuery({
        queryKey: ["contentCollection", { optionalTags: ["Interview Guide"], limit: 12, page: 1 }],
        queryFn: fetchContentCollection({
            tags: [],
            optionalTags: ["Interview Guide"],
            limit: 12,
            page: 1,
        }),
    });

    return (
        <div className="interview-guides-wrapper">
            <Heading level="h5">{t("LearnWithHubert.InterviewGuides")}</Heading>
            <HorizontalLine weight="semi-dark" />
            <ArticleCardList
                articles={contentCollection?.contents}
                wrapperClass="grid-items-wrapper"
                loading={loading}
            />
        </div>
    );
};

export default InterviewGuides;
